var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.008 23.0399C29.7154 24.5333 28.472 25.6713 26.936 25.8846C24.522 26.2399 20.4987 26.6666 15.9634 26.6666C11.5014 26.6666 7.47804 26.2399 4.99071 25.8846C3.45471 25.6713 2.21071 24.5333 1.91871 23.0399C1.62604 21.4046 1.33337 18.9866 1.33337 15.9999C1.33337 13.0133 1.62604 10.5953 1.91871 8.95992C2.21137 7.46659 3.45471 6.32859 4.99071 6.11525C7.40471 5.75992 11.428 5.33325 15.9634 5.33325C20.4987 5.33325 24.4487 5.75992 26.936 6.11525C28.472 6.32859 29.716 7.46659 30.008 8.95992C30.3007 10.5953 30.6667 13.0133 30.6667 15.9999C30.5934 18.9866 30.3007 21.4046 30.008 23.0399Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M21.568 14.9601L13.944 9.87746C13.5593 9.62079 13.068 9.59679 12.6607 9.81546C12.2533 10.0335 12 10.4555 12 10.9175V21.0828C12 21.5448 12.2533 21.9674 12.6607 22.1854C12.846 22.2848 13.048 22.3334 13.25 22.3334C13.4927 22.3334 13.734 22.2628 13.9433 22.1234L21.5673 17.0408C21.916 16.8081 22.124 16.4195 22.124 16.0008C22.1247 15.5815 21.916 15.1928 21.568 14.9601Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M13.7873 10.1579L20.9807 14.9539C21.44 15.2839 21.7493 15.5792 21.7493 15.9626C21.7493 16.3459 21.6 16.6132 21.2727 16.8519C21.0253 17.0319 13.9093 21.7612 13.9093 21.7612C13.3086 22.1639 12.3333 22.0786 12.3333 20.7619V11.1626C12.3333 9.82591 13.3893 9.89258 13.7873 10.1579Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 21.0454V10.9554C12.6667 10.4601 13.2187 10.1641 13.6314 10.4394L21.1993 15.4848C21.568 15.7301 21.568 16.2714 21.1993 16.5174L13.6314 21.5628C13.2187 21.8368 12.6667 21.5414 12.6667 21.0454Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6.54404,
    y1: 6.58059,
    x2: 27.4974,
    y2: 27.5339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#EE3D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E52030"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.32bbe7b1ff55ea4574e5e4c71fe6a388.svg";
export { ForwardRef as ReactComponent };